<div>
  <section>
    <div class="row mx-0 mb-2">
      <div class="col-10 px-0">
        <h3>
          Active Manufacturer Restricted NDCs
        </h3>
        <p>For the following NDCs, claims will automatically expire and become ineligible for referral capture once the number of days in the claim expiration period has passed since the claim's service date. To add or remove NDCs from this list, or to adjust the expiration period, reach out to your NuvemRx contact</p>
      </div>
    </div>

    <div class="container-fluid p-2 mb-2">
      <form>
        <div class="row align-items-end">

          <div class="col-3">
            <div class="mb-3">
              <label><strong>Search NDC:</strong></label>
              <input
                type="text"
                class="form-control"
                name="ndc"
                placeholder="Search by NDC"
                [(ngModel)]="filters.ndc"
                (keyup)="onFilterChangeWithDebounce()" />
            </div>
          </div>

          <div class="col-3">
            <div class="mb-3">
              <label><strong>Search Drug:</strong></label>
              <input
                type="text"
                class="form-control"
                name="drugDescription"
                placeholder="Search by Drug Description"
                [(ngModel)]="filters.drugDescription"
                (keyup)="onFilterChangeWithDebounce()" />
            </div>
          </div>

          <div class="col-3">
            <div class="mb-3">
              <label><strong>Manufacturer:</strong></label>
              <ng-select
                class="w-100"
                name="manufacturer"
                placeholder="All Manufacturers"
                [multiple]="true"
                [items]="manufacturers"
                (remove)="onFilterChange()"
                (change)="onFilterChange()"
                [(ngModel)]="filters.selectedManufacturers" />
            </div>
          </div>

          <div class="col-auto mb-3">
            <button type="button" class="btn btn-info mt-0 clear-button" (click)="onResetFiltersClick()">Clear</button>
            <a class="btn btn-primary" routerLinkActive="active" routerLink="{{ exportUrl }}">
              Export
            </a>
          </div>

        </div>
      </form>
    </div>

    <app-pagination-header
      [label]="'Manufacturer Restricted NDCs'"
      [paging]="paging"
      (pageSizeChange)="onPageSizeChange($event)" />

    @if (!loading) {
      <table class="table table-bordered table-hover">
        <thead class="table-dark">
          <tr>
            <th scope="col" class="col-2">NDC</th>
            <th scope="col" class="col-3">MANUFACTURER</th>
            <th scope="col" class="col-6">DRUG DESCRIPTION</th>
            <th scope="col" class="col-1">CLAIM EXPIRATION PERIOD (DAYS)</th>
          </tr>
        </thead>
        <tbody>
          @if (clientEspNdcs.length > 0) {
            @for (clientEspNdc of clientEspNdcs; track clientEspNdc) {
              <tr>
                <td>{{ clientEspNdc.ndc }}</td>
                <td>{{ clientEspNdc.manufacturerName }}</td>
                <td>{{ clientEspNdc.drugDescription }}</td>
                <td>{{ clientEspNdc.expirationInDays }}</td>
              </tr>
            }
          } @else {
            <tr>
              <td colspan="4">No Manufacturer Restricted NDCs found</td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <mat-spinner diameter="30" />
    }

    <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
  </section>
</div>